import React from 'react';
import { Dna } from 'react-loader-spinner';
import { RotatingTriangles } from 'react-loader-spinner';


const Preloader = () => {
    return (
        <div style={{ backgroundColor: '#111d30', width: '100%', height: '100vh',display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center' }}>
            
            <Dna
                visible={true}
                height="120"
                width="120"
                ariaLabel="dna-loading"
                wrapperStyle={{}}
                wrapperClass="dna-wrapper"
                
            />
            
        </div>
    )
}

export default Preloader;